import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

interface ITabButtonProps {
	/** Button label */
	children: ReactNode;
	/** Whether the tab button is currently selected */
	selected?: boolean;
	width?: string | undefined;
}

/**
 * @component A tab button.
 */
export const TabButton = styled.button<ITabButtonProps>`
	width: ${props => props.width ?? ''};
	height: 45px;
	color: ${themeGet('colors.darkGrey')};
	background-color: transparent;
	text-align: center;
	font-family: ${themeGet('fonts.base')};
	font-size: ${themeGet('fontSizes.small')};
	font-weight: 700;
	margin: 0px;
	padding: 0px 16px;
	border: ${themeGet('borders.none')};
	border-bottom: ${themeGet('borders.normal')};
	border-bottom-color: ${props => props.selected ? themeGet('colors.primary') : 'transparent'};
	outline: none;
	cursor: pointer;
	transition: color 0.2s ease, border-bottom-color 0.2s ease, background-color 0.2s ease;

	@media (max-width: 1000px) {
		padding: 0px 8px;
	}

	@media (prefers-reduced-motion: reduce) {
		transition: none;
	}

	:hover {
		background-color: ${themeGet('colors.lightestGrey')};
	}

	:disabled {
		color: ${themeGet('colors.lightGrey')};
		cursor: default;
	}
`;